import { Box, Card, CardContent, CardHeader, IconButton, ListItemIcon, Menu, MenuItem, Skeleton, TextField, Tooltip, Typography } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { useEffect, useState } from "react";
import Decimal from "decimal.js";
import { formatCurrency } from "../../../helpers/financialHelpers";

const InvoiceBillingItemsServicesCard = ({ servicesId, servicesName, servicesValue, onRemove, loading, onQuantityChange, quantity }) => {
    const [menuCardEl, setMenuCardEl] = useState(null);
    const [servicesQuantity, setServicesQuantity] = useState(
        quantity !== undefined && quantity !== null ? quantity : 1
    );
    const [lastValidServiceQuantity, setLastValidServiceQuantity] = useState(
        quantity !== undefined && quantity !== null ? quantity : 1
    );

    const openMenu = Boolean(menuCardEl);

    const handleClickMenu = (event) => {
        setMenuCardEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setMenuCardEl(null);
    };

    const handleServicesQuantityChange = (e) => {
        const val = e.target.value;
        if (val === '') {
            setServicesQuantity('');
            return;
        }

        const normalizedVal = val.replace(',', '.');
        const numberVal = Number(normalizedVal);

        if (!isNaN(numberVal) && numberVal >= 0) {
            setServicesQuantity(val);
            setLastValidServiceQuantity(val);
        }
    };

    const handleServicesQuantityBlur = () => {
        if (servicesQuantity === '') {
            setServicesQuantity(lastValidServiceQuantity);
        } else {
            setServicesQuantity(servicesQuantity);
            setLastValidServiceQuantity(servicesQuantity);
        }
    };

    const totalValue = new Decimal(servicesValue || 0).times(
        Number((servicesQuantity === '' ? lastValidServiceQuantity : servicesQuantity).toString().replace(',', '.'))
    );

    useEffect(() => {
        const quantity = servicesQuantity === '' ? lastValidServiceQuantity : servicesQuantity;
        const normalizedQuantity = Number(quantity.toString().replace(',', '.'));
        onQuantityChange?.(normalizedQuantity);
    }, [servicesQuantity, lastValidServiceQuantity, onQuantityChange]);
    return (
        <>
            <Box sx={{ mb: 2 }}>
                <Card
                    sx={{
                        backgroundColor: 'background.paper',
                    }}
                >
                    <CardHeader
                        title={
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1rem' }}>
                                <Typography variant="h6">{servicesName}</Typography>
                                <Tooltip title="">
                                    <span>
                                        <IconButton
                                            aria-label="more"
                                            onClick={handleClickMenu}
                                            aria-controls={openMenu ? 'long-menu' : undefined}
                                            aria-expanded={openMenu ? 'true' : undefined}
                                            aria-haspopup="true"
                                            sx={{
                                                border: 'none',
                                                '&:hover': { backgroundColor: 'transparent' },
                                                '&:focus': { outline: 'none' },
                                            }}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Menu
                                    id="long-menu"
                                    anchorEl={menuCardEl}
                                    open={openMenu}
                                    onClose={handleCloseMenu}
                                    slotProps={{
                                        list: {
                                            'aria-labelledby': 'long-button',
                                        },
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => {
                                            handleCloseMenu();
                                            onRemove?.();
                                        }}
                                    >
                                        <ListItemIcon>
                                            <CloseRoundedIcon fontSize="medium" />
                                        </ListItemIcon>
                                        <Typography variant="body1">Remover da fatura</Typography>
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            handleCloseMenu();
                                            if (servicesId) {
                                                window.open(`/services/${servicesId}/edit`, '_blank');
                                            }
                                        }}
                                    >
                                        <ListItemIcon>
                                            <AssignmentRoundedIcon fontSize="medium" />
                                        </ListItemIcon>
                                        <Typography variant="body1">Ver detalhes</Typography>
                                    </MenuItem>
                                </Menu>
                            </Box>
                        }
                    />
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <Box sx={{ p: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1">Preço </Typography>
                                {loading ? (
                                    <Skeleton variant="h3" width={60} />
                                ) : (
                                    <Typography variant="body1">R$ {formatCurrency(servicesValue)}</Typography>
                                )}
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1">Quantidade</Typography>
                                <TextField
                                    type="text"
                                    value={servicesQuantity}
                                    onChange={handleServicesQuantityChange}
                                    onBlur={handleServicesQuantityBlur}
                                    sx={{ maxWidth: '6rem' }}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '1rem' }}>
                            <Typography variant="h6" sx={{ color: 'primary.main' }}>Total</Typography>
                            {loading ? (
                                <Skeleton variant="h3" width={60} />
                            ) : (
                                <Typography variant="h6" sx={{ color: 'primary.main' }}>R$ {formatCurrency(totalValue)}</Typography>
                            )}
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </>
    )
}

export default InvoiceBillingItemsServicesCard;